<template>
  <div class="relative">
    <div
      class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer"
      v-if="planBenefit.privacyControl && !planBenefit.privacyControl.participantInfoCollection"
      @click="handleCheckNeedUpgradePlan()"
    ></div>
    <div class="overlay-disable-setting" v-if="!canEditPresentation"></div>
    <div class="relative flex justify-items-center align-middle" @click.capture="clickForUserNotPaid()">
      <aha-checkbox
        id="settings-check-audience-admission"
        @change="handleCheckBoxAudienceAdmission"
        v-model="presentation.audienceAdmission.isAudienceAdmission"
        class="mb-3 remove-css-disable"
        :disabled="isDisableAudienceAdmisstion"
      >
        <span>
          {{ $i18nPresenter.t('Require participants to enter information') }}
          <span v-if="!canUseNewTooltip">
            <IconNeedUpgradePlan
              ref="iconNeedUpgradePlanComponentAudienceInfor"
              :noPermission="planBenefit.privacyControl &&
                !planBenefit.privacyControl.participantInfoCollection"
              :defaultTooltip="$i18nPresenter.t('Show an entry form for the participants to fill in upon joining.')"
              left="-200px"
              :upgradePlan="planBenefit.privacyControl.participantInfoCollection_planName"
              featureName="Audience Addmission"
              v-if="planBenefit.interactivePresentation"
            />
          </span>
          <span v-else>
            <UpgradeIcon
              ref="iconNeedUpgradePlanComponentAudienceInfor"
              :noPermission="planBenefit.privacyControl &&
                !planBenefit.privacyControl.participantInfoCollection"
              :defaultTooltip="$i18nPresenter.t('Show an entry form for the participants to fill in upon joining.')"
              :upgradePlan="planBenefit.privacyControl.participantInfoCollection_planName"
              featureName="Audience Addmission"
              v-if="planBenefit.interactivePresentation"
            />
          </span>
        </span>
      </aha-checkbox>
    </div>
    <p class="text-xs" v-if="integrationPlatform !== 'GoogleSlide'">
      {{ $i18nPresenter.t("Participants' info is collected in the Excel file containing your presentation report.") }}
      {{ $i18nPresenter.t('Please go to:') }}
      <aha-link
        @click="showResultsMenu"
        type="primary"
        variant="primary"
      >
        <span class="text-xs font-bold">{{ $i18nPresenter.t('Report') }}</span>
      </aha-link> {{ $i18nPresenter.t('to download the file.') }}
    </p>
    <div class="mt-3 form-group" v-if="presentation.audienceAdmission.isAudienceAdmission">
      <label class="label-option" for="audience-admission-heading">
        {{ $i18nPresenter.t('Heading') }}
      </label>
      <aha-input
        :maxLength="150"
        :placeholder="$i18nPresenter.t('Your welcome line…')"
        class="mt-2 mb-4"
        id="audience-admission-heading"
        @input="handleOnInput"
        v-model="presentation.audienceAdmission.heading"
      />
      <AdditionalFieldsForm
        @updateAdditionalFields="updateAdditionalFields"
        :limitFields="limitFields"
        :presetFields="presetFields"
        type="audienceAdmission"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AdditionalFieldsForm from '@/components-v2/presentation-editor/side-right/AdditionalFieldsForm.vue'
import IconNeedUpgradePlan from '@/components-v2/my-plan/IconNeedUpgradePlan.vue'
import UpgradeIcon from '@/components-v2/my-plan/UpgradeIcon.vue'
import constants from '@/constant'

export default {
  components: {
    AdditionalFieldsForm,
    IconNeedUpgradePlan,
    UpgradeIcon,
  },
  props: {
    handleCheckBoxAudienceAdmission: {
      type: Function,
      default: () => {},
    },
    handleOnInput: {
      type: Function,
      default: () => {},
    },
    updateAdditionalFields: {
      type: Function,
      default: () => {},
    },
    showResultsMenu: {
      type: Function,
      default: () => {},
    },
    clickForUserNotPaid: {
      type: Function,
      default: () => {},
    },
    limitFields: {
      type: Number,
      default: 3,
    },
    presetFields: {
      type: Object,
      default: () => constants.audienceAdmissionFields,
    },
  },

  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      canEditPresentation: (state) => state.canEditPresentation,
      planBenefit: (state) => state.planBenefit,
      integrationPlatform: (state) => state.integrationPlatform,
    }),
    ...mapGetters('featureToggles', ['canUseNewTooltip']),
    audienceAdmissionTooltip() {
      return this.$i18nPresenter.t('Show an entry form for the participants to fill in upon joining')
    },
    isBeforeCurrentPeriodStart() {
      return this.$store.state.currentUser.isBeforeCurrentPeriodStart
    },
    isPlanFree() {
      return !this.$store.state.plan || this.$store.state.plan.group === 'free'
    },

    isDisableAudienceAdmisstion() {
      if (this.isPlanFree && this.isBeforeCurrentPeriodStart) return true
      if (this.planBenefit.privacyControl && !this.planBenefit.privacyControl.participantInfoCollection) return true
      return false
    },
  },
  methods: {
    handleCheckNeedUpgradePlan() {
      if (this.planBenefit.privacyControl && !this.planBenefit.privacyControl.participantInfoCollection) {
        this.$refs.iconNeedUpgradePlanComponentAudienceInfor.toggleTooltip()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.overlay-disable-setting {
  @apply bg-base-0 opacity-50 absolute left-0 top-0 w-full h-full z-20;
}
.cta-upgrade{
  left: calc(50% - 180px);
}
.icon-pro{
  margin-top: -13px;
}
.setting-audience-admission::v-deep {
  .aha-checkbox.inline-flex {
    display: inline-flex !important; // overwrite CSS bootstrap
  }
}
</style>
